import { render, staticRenderFns } from "./TipsNotification.vue?vue&type=template&id=c616f9c4"
import script from "./TipsNotification.vue?vue&type=script&lang=js"
export * from "./TipsNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports